export class DateSettings {
    public routeId: string;
    public date: Date;
    public routeLength: number;

    constructor();
    constructor(routeId: string, date: Date, routeLength: number);
    constructor(routeId?: string, date?: Date, routeLength?: number) {
        if (routeId) {
            this.routeId = routeId;
            this.date = date;
            this.routeLength = routeLength;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/date-settings-viewmodel.ts